import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./state/store";
import Vuelidate from "vuelidate";
import VueTheMask from "vue-the-mask";
import {
  BootstrapVue,
  BootstrapVueIcons,
  ModalPlugin,
  TimePlugin
} from "bootstrap-vue";
import VueClipboard from "vue-clipboard2";
import VueGeolocation from "vue-browser-geolocation";
import ActionCableVue from "actioncable-vue";
import LoadScript from "vue-plugin-load-script";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { registerBaseComponentsGlobally } from "./globals/components";
import Swal from "sweetalert2";
import protectSwalFromTranslate from "./utils/swalNoTranslate";
import Toast from "vue-toastification";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "vue-toastification/dist/index.css";
import "swiper/css/swiper.css";

window.addEventListener("load", () => {
  if (window.Iugu) {
    window.Iugu.setAccountID(process.env.VUE_APP_IUGU_ACCOUNT_ID);
    if (process.env.NODE_ENV !== "production") {
      window.Iugu.setTestMode(true);
    }
  }
});

registerBaseComponentsGlobally();

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectionUrl: process.env.VUE_APP_WS_BASE_PATH,
  connectImmediately: true
});

Vue.use(ModalPlugin);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueTheMask);
Vue.use(TimePlugin);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueGeolocation);
Vue.use(LoadScript);
Vue.use(Toast, {});
Vue.use(VueAwesomeSwiper);
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN || "",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
});

window.swal = Swal.mixin({
  confirmButtonColor: "#ED135A",
  cancelButtonColor: "#d33",
  confirmButtonText: "Confirmar",
  cancelButtonText: "Cancelar",
  didOpen: protectSwalFromTranslate
});

Vue.config.productionTip = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
